import { render } from "./ThePathCharacter.vue?vue&type=template&id=388b3216&scoped=true"
import script from "./ThePathCharacter.vue?vue&type=script&lang=js"
export * from "./ThePathCharacter.vue?vue&type=script&lang=js"

import "./ThePathCharacter.vue?vue&type=style&index=0&id=388b3216&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-388b3216"]])

export default __exports__